export default __webpack_public_path__ + "static/media/card_3.dd404104.png";